import { ParamsAdapter } from './params.adapter';

/**
 * @public
 */
export class DefaultParams extends ParamsAdapter {
  constructor(private attributes: unknown = {}) {
    super();
  }

  getParams(): unknown {
    return this.attributes;
  }
}
